import Agents, { getServerSideProps } from './Agents';
export default Agents;
export { getServerSideProps };
